// extracted by mini-css-extract-plugin
export default {"tupacGrid":"vn-z","tupacHeader":"wn-z","tupacHeader2":"xn-z","tupacMenu":"yn-z","tupacMenu2":"zn-z","tupacMain":"An-z","tupacMain2":"Bn-z"};